<template>
<b-col sm="2">
  <b-card
    @click="select(item)"
    :style="{ cursor: 'pointer'}"
    no-body style="max-width: 20rem;"
    img-alt="site screenshot"
    img-top>
  <template v-slot:header>
    <span>
      <a v-if="item && item.config && item.config.seeds.length > 0" target="_blank" :href="item.config.seeds[0]" class="card-link">
        <i class="fa fa-share"></i>
         # {{index+1}}
         {{item.fqdn}}
      </a>
      <span v-else>{{item.fqdn}} </span>
    </span>
  </template>
    <b-card-body class="text-center">
      <!-- <b-card-sub-title class="mb-2">Card Sub Title</b-card-sub-title> -->
      <!-- <b-card-text> asd </b-card-text> -->

      <span v-if="loading">
        <div :class="`spinner-grow ${colors[item.id % colors.length]}`" role="status">
        </div>
      </span>
      <b-card-img class="animated fadeIn" v-else :src="item.img ? item.img : img" alt="Image" bottom></b-card-img>
      <!-- <b-card-img v-else src= alt="Image" bottom></b-card-img> -->
      <!-- <b-card-text v-else>
        <b-img src="img/no-image.png" width="80%" alt="no have latest scanning image"></b-img>
      </b-card-text> -->
    </b-card-body>

    <b-list-group flush class="text-center">
      <b-list-group-item>
        <span v-if="item.last_visit">{{item.last_visit | utcsdate}}</span>
        <span v-else>Ready</span>
      </b-list-group-item>
      <!-- <b-list-group-item>
        <span v-if="item.finished_at">{{item.finished_at | sdate}}</span>
        <span v-else></span>
      </b-list-group-item> -->
    </b-list-group>

    <b-card-footer v-if="item" class="text-center">
      <h4>
        <b-button variant="danger" v-if="item.detect_count > 0">
          Danger <b-badge variant="light">{{item.detect_count}}</b-badge>
        </b-button>
        <b-badge v-else variant="success">Safety</b-badge>
        <b-button variant="warning" v-if="item.error_count > 0">
          Error <b-badge variant="light">{{item.error_count}}</b-badge>
        </b-button>
        <b-button variant="dark" v-if="item.page_count < 1">
          Inspection Failed
        </b-button>


      </h4>
    </b-card-footer>
  </b-card>
  </b-col>
</template>

<script>
import { Api } from '@/service';

export default {
  components: { },
  watch: {
    item() {
      this.load_image()
    }
  },
  data: () => {
    return {
      loading : true,
      start : true,
      img : '',
      colors : [
        "text-primary",
        "text-secondary",
        "text-success",
        "text-warning",
        "text-danger",
        "text-info",
        "text-light",
        "text-dark"
      ]
    }
  },
  computed : {
  },
  props: ['item', 'index'],
  methods: {
    load_image() {
      let so = {
        target : 'site', cmd : 'detail.thumbnail',
        body : { site_id : this.item.id },
      }
      // 이미지 로드의 경우, 한번 로딩 이슈 브라우저 캐시를 사용하게 됨
      // 받아오는 이미지의 경우도 처리가 된 경우임
      // 사이트 아이디가 있을 경우 점검 결과만 로드 함, 속도 이슈

      if(this.$route.params && this.$route.params.site_id) { return console.log('not load img') }
      return Api.Manager(so)
        .then(rs => {
          this.img = rs && rs.body ? 'data:image/png;base64,'+rs.body : "img/no-image.png"; this.loading = false
          this.img + `?ts=${new Date().getTime()}`
        })
        .catch(e =>
          {
            this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)
            this.img = 'img/no-image.png'
          }
        )
    },
    select(i) { this.$emit("click", i); },
  },
  destroyed () { console.log('Result.Grid.vue destroyed') },
  mounted () { console.log('Result.Grid.vue mounted'); this.$emit('load', 1); this.load_image() },
}
</script>
